var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 18,
    viewBox: "0 0 114 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.666688,
    cy: 0.666688,
    r: 0.666688,
    transform: "matrix(1 0 0 -1 61.3359 12)",
    fill: "#A54C85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.0026,
    cy: 0.666688,
    r: 0.666688,
    fill: "#A54C85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.6674,
    cy: 11.3334,
    r: 1.33338,
    fill: "#A54C85"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.666688,
    cy: 0.666688,
    r: 0.666688,
    transform: "matrix(-1 0 0 1 48.002 12.666)",
    fill: "#A54C85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0007,
    cy: 11.3337,
    r: 0.666688,
    fill: "#A54C85"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.666688,
    cy: 0.666688,
    r: 0.666688,
    transform: "matrix(1 0 0 -1 26.668 4.66699)",
    fill: "#A54C85"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3334,
    cy: 16.6674,
    r: 1.33338,
    fill: "#A54C85"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.00006,
    cy: 6.66705,
    r: 2.00006,
    fill: "#A54C85"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00067,
    cy: 15.3337,
    r: 0.666688,
    fill: "#A54C85"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3353,
    cy: 11.3334,
    r: 1.33338,
    fill: "#A54C85"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.004,
    cy: 13.3331,
    r: 2.00006,
    fill: "#A54C85"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.666688,
    cy: 0.666688,
    r: 0.666688,
    transform: "matrix(-1 0 0 1 99.3359 6)",
    fill: "#A54C85"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.669,
    cy: 16.6673,
    r: 0.666688,
    transform: "rotate(180 112.669 16.6673)",
    fill: "#A54C85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.f2a605ea8c0013e4fdf207a4c958636f.svg";
export { ForwardRef as ReactComponent };